import styled, { css } from 'styled-components';

interface WrapperProps {
    isAnimated: boolean;
    disableShine: boolean;
    hasLongTwitter: boolean;
    isSmall?: boolean;
    hoverEffect?: boolean;
}

interface PickerOuterProps {
    isSmall?: boolean;
}

interface PickerProps {
    isSmall?: boolean;
    hasOnlyOne?: boolean;
}

const activeStyling = css`
    .picker > div {
        background: linear-gradient(30deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.6) 190%);

        div {
            background: rgba(28, 26, 41, 0.2);
        }
    }
`;

export const Wrapper = styled.div<WrapperProps>`
    position: relative;
    display: inline-flex;
    flex-direction: row-reverse;

    svg {
        fill: transparent;
    }

    ${({ hoverEffect }) =>
        hoverEffect &&
        css`
            cursor: pointer;
            &:hover {
                ${activeStyling}
            }
        `};

    ${({ isAnimated, disableShine }) =>
        isAnimated &&
        !disableShine &&
        css`
            ${activeStyling}
        `};

    ${({ isSmall }) =>
        isSmall &&
        css`
            transform: scale(0.9);
            @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
                transform: scale(0.65);
            }
        `};

    ${({ hasLongTwitter, isSmall }) =>
        hasLongTwitter &&
        isSmall &&
        css`
            transform: scale(0.77);
            @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
                transform: scale(0.6);
            }
        `};
`;

export const PickerOuter = styled.div<PickerOuterProps>`
    overflow: hidden;
    border-radius: 500px;
    background: rgba(28, 26, 41, 1);
    height: 132px;
    transition: 0.7s ease;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    font-size: 0;
    line-height: 0;
    position: relative;

    ${({ isSmall }) =>
        isSmall &&
        css`
            height: 66px;
        `};

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        height: 66px;
    }
`;

export const Picker = styled.div<PickerProps>`
    box-sizing: border-box;
    border-radius: 500px;
    padding: 2px;
    height: 132px;
    background: linear-gradient(20deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.5) 190%);
    transition: 0.7s ease;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0;
    line-height: 0;
    position: relative;

    > div {
        transition: 0.7s ease;
        border-radius: 500px;
        padding: 2px 34px;

        ${({ hasOnlyOne }) =>
            hasOnlyOne &&
            css`
                padding: 2px 20px;
            `};

        font-size: 5rem;
        line-height: 0;
        height: calc(100% - 4px);
        width: calc(100% - 4px);
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(28, 26, 41, 1);
        box-sizing: content-box;

        > span {
            margin: 0 4px;
            box-sizing: content-box;
        }
    }

    ${({ isSmall }) =>
        isSmall &&
        css`
            height: 66px;
            > div {
                padding: 2px 24px;
                font-size: 2.6rem;
            }
        `};

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        height: 66px;

        > div {
            padding: 2px 20px;
            font-size: 2.6rem;
        }
    }
    @media (max-width: 393px) {
        //  did not add to theme.breakpoints because this is specifically from this issue https://tari.atlassian.net/browse/SCY-162?focusedCommentId=16980
        // which i wasn't able to reproduce but it came back so added this as a failsafe
        > div {
            padding: 2px 10px;
            font-size: 2.2rem;
        }
    }
`;
